(function () {
  'use strict';
  if (window.__vivalleGoogle) return;
  const el = document.currentScript;
  const ga = el?.dataset.ga4 || '';
  const ads = el?.dataset.ads || '';
  const label = el?.dataset.label || '';
  const preview = Boolean(el?.dataset.preview === 'true' || window.Shopify?.designMode || /(?:preview_theme_id|vivalle_qa)=/.test(location.search));
  const state = window.__vivalleGoogle = { started: false, ga: false, ads: false, sent: new Set() };
  window.dataLayer = window.dataLayer || [];
  window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };
  function consent() {
    const p = window.Shopify?.customerPrivacy;
    try { return { analytics: Boolean(p?.analyticsProcessingAllowed()), marketing: Boolean(p?.marketingAllowed()) }; }
    catch (_) { return { analytics: false, marketing: false }; }
  }
  function apply() {
    if (preview) return;
    const c = consent();
    if (!state.started && !c.analytics && !c.marketing) return;
    if (!state.started) {
      window.gtag('consent', 'default', { analytics_storage: 'denied', ad_storage: 'denied', ad_user_data: 'denied', ad_personalization: 'denied' });
      window.gtag('js', new Date());
      state.started = true;
    }
    window.gtag('consent', 'update', { analytics_storage: c.analytics ? 'granted' : 'denied', ad_storage: c.marketing ? 'granted' : 'denied', ad_user_data: 'denied', ad_personalization: 'denied' });
    const config = { allow_google_signals: false, allow_ad_personalization_signals: false };
    if (c.analytics && /^G-[A-Z0-9]+$/.test(ga) && !state.ga) { window.gtag('config', ga, config); state.ga = true; }
    if (c.marketing && /^AW-\d+$/.test(ads) && !state.ads) { window.gtag('config', ads, config); state.ads = true; }
    if (!document.querySelector('script[data-vivalle-google-loader]') && (state.ga || state.ads)) {
      const script = document.createElement('script');
      script.async = true;
      script.dataset.vivalleGoogleLoader = 'true';
      script.src = 'https://www.googletagmanager.com/gtag/js?id=' + encodeURIComponent(state.ga ? ga : ads);
      document.head.appendChild(script);
    }
  }
  document.addEventListener('vivalle:order-confirmed', function (event) {
    const d = event.detail || {};
    const id = String(d.transaction_id || d.event_id || '');
    if (!id || !Number.isFinite(Number(d.value)) || Number(d.value) <= 0 || preview || state.sent.has(id)) return;
    const c = consent();
    apply();
    let sent = false;
    if (c.analytics && state.ga) {
      window.gtag('event', 'generate_lead', { send_to: ga, currency: 'MAD', quoted_order_value: Number(d.value), transaction_id: id, lead_source: 'cod_order', form_id: 'vivalle_cod' });
      sent = true;
    }
    if (c.marketing && state.ads && /^[A-Za-z0-9_-]+$/.test(label)) {
      window.gtag('event', 'conversion', { send_to: ads + '/' + label, transaction_id: id });
      sent = true;
    }
    if (sent) state.sent.add(id);
  });
  document.addEventListener('visitorConsentCollected', apply);
  if (window.Shopify?.customerPrivacy) apply();
  else if (typeof window.Shopify?.loadFeatures === 'function') window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) { if (!error) apply(); });
})();
